import kebabCase from 'lodash/kebabCase'

export const getSqaId = (id: string, prefix?: string, suffix?: string | number) => {
  // newId will be properly kebab cased, leading and trailing dashes
  // will be omitted if prefix or suffix are absent
  const newId = kebabCase(`${prefix ?? ''}_${id}_${suffix ?? ''}`)

  return {'data-sqa-id': newId}
}
